<template>
  <div class="tw-relative tw-flex tw-flex-col">
    <label :for="label"></label>
    <input
      :type="inputType"
      class="tw-text-sm tw-rounded tw-p-4 focus:tw-border-primary tw-border-[#DDE1E9]"
      :class="{
        'tw-border-error': showError === true,
      }"
      v-model="pass"
      @blur="$emit('validate', placeHolder)"
      :placeholder="placeHolder"
      :disabled="disabled"
      required
    />
    <button type="button" @click="showPassword" :disabled="!password">
      <img
        src="@/assets/img/eye.svg"
        class="tw-absolute tw-right-4 tw-bottom-5"
        alt="show password icon"
      />
      <img
        v-if="inputType === 'password'"
        src="@/assets/img/slash.svg"
        class="tw-absolute tw-right-3.5 tw-bottom-4"
        alt="show password icon"
      />
    </button>
    <p class="tw-absolute tw--top-4 tw-right-px tw-text-error tw-text-xs">
      {{ errorMsg }}
    </p>
  </div>
</template>

<script>
  export default {
    name: "OnboardingPasswordInput",
    emits: ["set", "validate"],
    props: {
      placeHolder: { type: String, default: () => "", required: true },
      label: { type: String, default: () => "", required: true },
      password: { type: String, default: () => "", required: true },
      error: { type: Object, default: () => {}, required: true },
      inputName: { type: String, default: () => "", required: true },
      disabled: { type: Boolean, default: () => false, required: true },
    },

    data() {
      return {
        inputType: "password",
        showError: false,
        errorMsg: "",
      };
    },

    computed: {
      pass:{
        get(){
          return this.password
        },
        set(value){
          this.$emit("set", value)
        },
      }
    },

    methods: {
      checkError() {
        switch (this.error.$property) {
          case "password":
            this.showError = true;
            this.errorMsg = this.error.$message;
            break;
          case "confirmPassword":
            this.showError = true;
            this.errorMsg = this.error.$message;
            break;

          default:
            this.showError = false;
            this.errorMsg = "";
            break;
        }
      },

      showPassword() {
        if (this.inputType === "password") {
          this.inputType = "text";
        } else {
          this.inputType = "password";
        }
      },
    },

    watch: {
      error(newValue, oldValue) {
        deep: true;
        immediate: true;
        if (newValue !== oldValue) {
          this.checkError();
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
